<form *ngIf="canShow" [formGroup]="formGroup" class="graph-options px-lg-8 px-md-8">
  <div class="row">
    <p-form-group label="{{ dashboardOptionsTurnoverString }}" class="col-lg-3 col-md-6">
      <ng-select
        id="turnover"
        formControlName="turnover"
        [items]="allowedTurnovers"
        [searchable]="false"
        [clearable]="false"
        bindValue="value"
        class="dashboard-select"
      >
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-option-label">{{ item.label }}</span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label">{{ item.label }}</span>
        </ng-template>
      </ng-select>
    </p-form-group>

    <p-form-group label="{{ dashboardOptionsDateTypeString }}" class="col-lg-3 col-md-6">
      <ng-template #tipContent><div [innerHTML]="dashboardOptionsTooltipString"></div></ng-template>
      <ng-template #tipContentToma 
        ><div>
          Über Ihr persönliches Dashboard erhalten Sie Zugriff auf die folgenden Informationen:<br /><br />
          <strong>1 - Reisesaison zeigt</strong>, wenn Ihre Kunden unterwegs sind<br />
          <strong>2 - Buchungsdatum zeigt</strong>, wann die Buchung getätigt wurde<br />
          <br />Dashboard-Daten werden direkt Ihren aktuellen geschäftlichen Aktivitäten entnommen.<br />
          TOMA Buchungen beinhalten alle Vorgänge, Buchungen als auch Optionen.
        </div>
      </ng-template>
      <span
        class="fa-circle-info fa-solid ps-2 text-secondary"
        [ngbTooltip]="'TOMA' === formGroup.get('turnover').value ? tipContentToma : tipContent"
        placement="bottom"
        tooltipClass="bottom"
        container="body"
      ></span>
      <ng-select
        id="data-type"
        formControlName="dateType"
        [items]="allowedDateTypes"
        [searchable]="false"
        [clearable]="false"
        bindValue="value"
        class="dashboard-select"
      >
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-option-label">{{ item.label }}</span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label">{{ item.label }}</span>
        </ng-template>
      </ng-select>
    </p-form-group>

    <p-form-group label="{{ dashboardOptionsStartDateString }}" class="col-lg-3 col-md-6">
      <div class="input-group df-input-append"
          >
        <input #fromDate
               class="append df-input-withicon form-control"
               pFormControlInput
               formControlName="dateFrom"
               name="dateFrom"
               id="dateFrom"
               placeholder="YYYY-MM-DD"
               aria-label="Date"
               name="dp"
               ngbDatepicker
               #dp="ngbDatepicker"
               [navigation]="'arrows'"
               [outsideDays]="'collapsed'"
               [dayTemplate]="dpdt"
               [markDisabled]="isDisabled"
               (dateSelect)="fromDate.focus()"
               
               [minDate]="minDateFrom"
               (keyup.enter)="dp.onBlur()"/>
        <div class="input-group-append">
          <button class="input-group-text fa-calendar"
                  (click)="dp.toggle()"
                  type="button"><span class="visually-hidden">Toggle
              datepicker</span></button>
        </div>
      </div>
    </p-form-group>

    <p-form-group label="{{ dashboardOptionsEndDateString }}" class="col-lg-3 col-md-6">
       <div class="input-group df-input-append"
          >
        <input #toDate
               class="append df-input-withicon form-control"
               pFormControlInput
               formControlName="dateTo"
               name="dateTo"
               id="dateTo"
               placeholder="YYYY-MM-DD"
               aria-label="Date"
               name="dp2"
               ngbDatepicker
               #dp2="ngbDatepicker"
               [navigation]="'arrows'"
               [outsideDays]="'collapsed'"
               [markDisabled]="isDisabled"
               (dateSelect)="toDate.focus()"
               
               [minDate]="minDateFrom"
               [dayTemplate]="dpdt"
               (keyup.enter)="dp2.onBlur()"/>
        <div class="input-group-append">
          <button class="input-group-text fa-calendar"
                  (click)="dp2.toggle()"
                  type="button"><span class="visually-hidden">Toggle
              datepicker</span></button>
        </div>
      </div>
    </p-form-group>
  </div>
</form>

<ng-template #dpdt
             let-date
             let-disabled="disabled"
             let-focused="focused"
             let-selected="selected">
  <div class="df-datepicker-date"
       [class.df-datepicker-date-disabled]="disabled"
       [class.df-datepicker-date-focused]="focused"
       [class.df-datepicker-date-selected]="selected"
       role="link">
    {{date.day}}
  </div>
</ng-template>